export default function BookingInfo() {
  const steps = [
    {
      icon: "ri-calendar-check-line",
      title: "Book Your Slot",
      description:
        "Choose a convenient time for us to visit your property",
    },
    {
      icon: "ri-home-smile-line",
      title: "Site Assessment",
      description:
        "We'll evaluate the work required and discuss your vision",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Receive Your Quote",
      description:
        "Get a detailed, transparent quote with no hidden costs",
    },
  ];

  return (
    <section className="py-20 px-6 bg-beige-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-800 mb-4">
            How It Works
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto">
            Our simple booking process ensures you get an accurate quote for
            your project
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 text-center shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                <i className={`${step.icon} text-2xl text-primary-500`}></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center bg-neutral-800 text-white rounded-full mx-auto mb-4 text-sm font-bold">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-neutral-800 mb-3">
                {step.title}
              </h3>
              <p className="text-neutral-600 text-sm">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-lg p-8 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-neutral-800 mb-4">
                Visit Availability
              </h3>
              <p className="text-neutral-600 mb-6">
                We conduct site visits during convenient evening hours so you
                don&apos;t have to take time off work.
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-calendar-line text-primary-500 text-xl"></i>
                  </div>
                  <span className="text-neutral-700 font-medium">
                    Monday - Saturday
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-time-line text-primary-500 text-xl"></i>
                  </div>
                  <span className="text-neutral-700 font-medium">
                    5:00 PM - 7:00 PM
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-map-pin-line text-primary-500 text-xl"></i>
                  </div>
                  <span className="text-neutral-700 font-medium">
                    Watford &amp; Surrounding Areas
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-beige-50 rounded-lg p-6">
              <h4 className="font-bold text-neutral-800 mb-4">
                What to Expect
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-sky-600 mt-1"></i>
                  <span className="text-neutral-600 text-sm">
                    30-45 minute consultation at your property
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-sky-600 mt-1"></i>
                  <span className="text-neutral-600 text-sm">
                    Detailed assessment of surfaces and preparation needed
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-sky-600 mt-1"></i>
                  <span className="text-neutral-600 text-sm">
                    Discussion of colour options and finishes
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-sky-600 mt-1"></i>
                  <span className="text-neutral-600 text-sm">
                    Written quote within 24-48 hours
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg p-8 shadow-sm border border-neutral-100">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-neutral-800 mb-2">
                Prefer to speak with us directly?
              </h3>
              <p className="text-neutral-600 text-sm">
                Call us to discuss your project or arrange an alternative appointment time
              </p>
            </div>
            <a
              href="tel:+447595037441"
              className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap shadow-sm hover:shadow-md"
            >
              <i className="fas fa-phone text-lg"></i>
              <span className="text-lg">07595 037441</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
